/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const modulesMetaAdDataInputCityDataSchema = z.object({
	id: z.string(),
	radius: z.number(),
})

export type ModulesMetaAdDataInputCityDataSchema = z.infer<typeof modulesMetaAdDataInputCityDataSchema>
